import {
  CcfBox,
  CcfCalendarIcon,
  CcfHeader,
  CcfTabs,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getApplicationDirection } from '../../global.app.slice';
import styles from './ccf-app-wem.module.scss';
import { CcfAppSchedule, CcfWemLeftNav } from '@nice-ccf/ui-components';

/* eslint-disable-next-line */
export interface CcfAppWemProps {}

/**
 * CcfAppWem - used to display static image in wem landing page
 * @param props - CcfAppWemProps
 * @example `<CcfAppWem inboxCardState={inboxCardStateVal} `/`>`
 */
export function CcfAppWem(props: CcfAppWemProps) {
  const appDirection: any = useSelector(getApplicationDirection);
  const [tab, setTab] = useState(0);

  /**
   * Updating Tab index while Switching Tabs in home Panel to show tabs data
   * @param newTabIndex -number
   * @example - handleChange(1)
   */
  const handleChange = (newValue: number) => {
    setTab(newValue);
  };

  return (
    <CcfBox className={styles.ccfHomeContainer} style={{ width: '100%' }}>
      <CcfBox className={styles.wemContainer}>
        <CcfBox style={{ background: 'white', height: '100%' }}>
          <CcfBox className={styles.appSpaceHeader}>
            <CcfHeader
              headerText={'WEM'}
              headerTextClassess={styles.headerText}
              RightIcon={false}
              isNewWindowIcon
              direction={appDirection}
            ></CcfHeader>
          </CcfBox>
          <CcfWemLeftNav />
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}
